// Zeit-Helfer der Inbox (aus routes/Inbox.tsx herausgezogen, damit die
// P5-Kontextliste sie ohne Ringimport nutzen kann). Verhalten unveraendert.

export interface SnoozePreset {
  label: string;
  /** ISO-8601 datetime string. */
  until: string;
}

/**
 * Returns standard snooze presets relative to `now`.
 * Pure function — deterministic when `now` is fixed.
 */
export function snoozePresets(now: Date = new Date()): SnoozePreset[] {
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(9, 0, 0, 0);

  const nextWeek = new Date(now);
  nextWeek.setDate(nextWeek.getDate() + 7);
  nextWeek.setHours(9, 0, 0, 0);

  const nextMonth = new Date(now);
  nextMonth.setMonth(nextMonth.getMonth() + 1);
  nextMonth.setDate(1);
  nextMonth.setHours(9, 0, 0, 0);

  return [
    { label: "Morgen früh", until: tomorrow.toISOString() },
    { label: "Nächste Woche", until: nextWeek.toISOString() },
    { label: "Nächsten Monat", until: nextMonth.toISOString() },
  ];
}

/**
 * Format a relative timestamp (same as NotificationBell's relTime).
 */
export function relTime(iso: string): string {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "";
  const diffMs = Date.now() - t;
  const sec = Math.round(diffMs / 1000);
  if (sec < 60) return "gerade eben";
  const min = Math.round(sec / 60);
  if (min < 60) return `vor ${min} Min.`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `vor ${hr} Std.`;
  const days = Math.round(hr / 24);
  if (days < 7) return `vor ${days} Tag${days === 1 ? "" : "en"}`;
  return new Date(iso).toLocaleDateString("de-DE");
}

